import { render } from "./search.vue?vue&type=template&id=fc33525e&scoped=true"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"

import "./search.vue?vue&type=style&index=0&id=fc33525e&lang=scss&scoped=true"
import "./search.vue?vue&type=style&index=1&id=fc33525e&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc33525e"]])

export default __exports__